

import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { getMessaging } from "firebase/messaging";
import { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";
import "react-clock/dist/Clock.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-time-picker/dist/TimePicker.css";
import { toast } from "react-toastify";
import { useAuth } from "../context/AuthContext";
import { db } from "../firebase";


const formatDateToYYYYMMDD = (dateObj) => {
  if (!dateObj || !(dateObj instanceof Date) || isNaN(dateObj)) {
    dateObj = new Date();
  }
  const year = dateObj.getFullYear();
  const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
  const day = dateObj.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
};

function AddEventModal({
  showModal,
  setShowModal,
  userId,
  selectedDate,
  onEventAdded,
}) {
  const { globalUser, logOut } = useAuth();
  console.log("globalUser", globalUser?.uid);
  console.log("Event modal date selectedDate (raw prop):", selectedDate);
  const [loggedUser, setLoggedUser] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      const uid = globalUser?.uid;
      if (!uid) {
        console.log("User ID not available yet, skipping fetch.");
        return;
      }

      try {
        const userDocRef = doc(db, "lawyers", uid);
        const userDoc = await getDoc(userDocRef);
        if (userDoc.exists()) {
          const data = userDoc.data();
          console.log(" logged User data:", data);
          setLoggedUser(data);
        } else {
          console.log("No such document!");
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        toast.error("Failed to load user data.");
      }
    };

    fetchUserData();
  }, [globalUser]);

  // Initialize form state with added description field
  const [newEvent, setNewEvent] = useState({
    title: "",
    caseNo: "",
    description: "", // Added description field
  });

  const [date, setDate] = useState(() =>
    formatDateToYYYYMMDD(selectedDate || new Date())
  );

  const [time, setTime] = useState(() => {
    const now = new Date();
    if (selectedDate && selectedDate.toDateString() === now.toDateString()) {
      return now.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hourCycle: "h23",
      });
    } else if (selectedDate) {
      return "09:00";
    } else {
      return now.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hourCycle: "h23",
      });
    }
  });

  const [caseNumbers, setCaseNumbers] = useState([]);
  const [error, setError] = useState("");
  const [userMobile, setUserMobile] = useState("");
  const [isCaseDropdownOpen, setIsCaseDropdownOpen] = useState(false);
  const caseDropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        caseDropdownRef.current &&
        !caseDropdownRef.current.contains(e.target)
      ) {
        setIsCaseDropdownOpen(false);
      }
    };
    if (isCaseDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isCaseDropdownOpen]);




  useEffect(() => {
    if (showModal && selectedDate) {
      const formatted = formatDateToYYYYMMDD(selectedDate);
      console.log("Setting date state from prop:", formatted);
      setDate(formatted);
    } else if (showModal && !selectedDate) {
      const formatted = formatDateToYYYYMMDD(new Date());
      console.log("Setting date state to today (no prop):", formatted);
      setDate(formatted);
    }

    setTime(
      formatDateToYYYYMMDD(selectedDate || new Date()) ===
        formatDateToYYYYMMDD(new Date())
        ? new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          hourCycle: "h23",
        })
        : "09:00"
    );
  }, [selectedDate, showModal]);

  useEffect(() => {
    if ("Notification" in window) {
      Notification.requestPermission();
    }
  }, []);

  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      input[type="date"]::-webkit-calendar-picker-indicator,
      input[type="time"]::-webkit-calendar-picker-indicator {
        filter: invert(1);
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (!showModal || !userId) return;
      setError("");
      try {
        const q = query(
          collection(db, "pending"),
          where("owner", "==", userId)
        );
        const querySnapshot = await getDocs(q);
        const cases = querySnapshot.docs.map((doc) => doc.data().caseNo);
        setCaseNumbers(cases);

        const userQuery = query(
          collection(db, "lawyers"),
          where("uid", "==", userId)
        );
        const userDocSnapshot = await getDocs(userQuery);
        if (!userDocSnapshot.empty) {
          const userData = userDocSnapshot.docs[0].data();
          console.log("User data:", userData);
          console.log("User mobile:", userData.mobileWithCountryCode);
          setUserMobile(userData.mobileWithCountryCode || "");
        } else {
          console.warn("User document not found for UID:", userId);
          setUserMobile("");
        }
      } catch (err) {
        console.error("Error fetching data:", err);
        setError("Failed to load required data");
      }
    };
    fetchData();
  }, [showModal, userId]);

  const formatTimeString = (timeStr) => {
    if (!timeStr) return "";
    try {
      const [hours, minutes] = timeStr.split(":");
      if (isNaN(hours) || isNaN(minutes)) return timeStr;
      const date = new Date();
      date.setHours(parseInt(hours, 10));
      date.setMinutes(parseInt(minutes, 10));
      return date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    } catch (e) {
      console.error("Error formatting time:", e, "Input:", timeStr);
      return timeStr;
    }
  };

  const generateTimestamp = (dateStr, timeStr) => {
    try {
      const dateTimeString = `${dateStr}T${timeStr || "00:00"}:00`;
      const newDate = new Date(dateTimeString);

      if (isNaN(newDate.getTime())) {
        console.error(
          "Error generating timestamp: Invalid date/time string",
          dateTimeString
        );

        const fallbackDate = new Date(dateStr);
        return fallbackDate.getTime();
      }

      console.log(
        `Generated timestamp for ${dateStr} ${timeStr}: ${newDate.getTime()} (${newDate.toString()})`
      );
      return newDate.getTime();
    } catch (e) {
      console.error("Error generating timestamp:", e);
      return new Date(dateStr).getTime();
    }
  };

  const messaging = getMessaging();

  const showSuccessMessage = () => {
    toast.success("Event added successfully!");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!newEvent.title || !date || !time) {
      setError("Please fill all required fields");
      return;
    }
    if (newEvent.title.length > 100) {
      setError("Title should be less than 100 characters");
      return;
    }
    if (newEvent.description && newEvent.description.length > 1000) {
      setError("Description should be less than 1000 characters");
      return;
    }

    try {
      const timestamp = generateTimestamp(date, time);
      if (isNaN(timestamp)) {
        setError("Invalid date or time entered.");
        return;
      }

      const eventData = {
        title: newEvent.title,
        date: date,
        time: formatTimeString(time),
        time1: timestamp,
        mobile: userMobile || null,
        "Case No": newEvent.caseNo,
        description: newEvent.description || "",
        isScheduled: true,
        isGoogleEvent: false,
      };

      const docRef = await addDoc(
        collection(db, "lawyers", userId, "events"),
        eventData
      );
      console.log("Document written with ID:", docRef.id);
      onEventAdded();

      // Create reminders
      const eventTime = new Date(timestamp);
      const now = new Date();

      // First reminder: at the event time
      if (eventTime > now) {
        const firstReminderDoc = {
          eventId: docRef.id,
          reminderTime: eventTime,
          eventTitle: "Your event is happening now",
          caseNo: newEvent.caseNo || "",
          status: "pending",
          createdAt: new Date(),
          scheduledBy: userId,
          recipientId: userId,
        };
        await addDoc(collection(db, "eventReminders"), firstReminderDoc);
        console.log("First reminder created at event time.");
      } else {
        console.log("Event time is in the past, not creating first reminder.");
      }

      // Second reminder: 5 minutes before the event
      const fiveMinBefore = new Date(timestamp - 300000); // Subtract 5 minutes (300000 milliseconds)
      if (fiveMinBefore > now) {
        const secondReminderDoc = {
          eventId: docRef.id,
          reminderTime: fiveMinBefore,
          eventTitle: newEvent.title,
          caseNo: newEvent.caseNo || "",
          status: "pending",
          createdAt: new Date(),
          scheduledBy: userId,
          recipientId: userId,
        };
        await addDoc(collection(db, "eventReminders"), secondReminderDoc);
        console.log("Second reminder created 5 minutes before the event.");
      } else {
        console.log("5 minutes before the event is in the past, not creating second reminder.");
      }



      toast.success("Event added successfully!");
      setNewEvent({ title: "", caseNo: "", description: "" });
      setDate(formatDateToYYYYMMDD(new Date()));
      setTime(
        new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          hourCycle: "h23",
        })
      );
      setError("");
      onEventAdded();
      setShowModal(false);
    } catch (err) {
      console.error("Error adding event:", err);
      setError(`Failed to add event: ${err.message}`);
    }
  };

  return (
    <>
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50 px-4 sm:px-0 py-6">
          {/* ... Backdrop ... */}
          <div
            className="absolute inset-0 bg-black bg-opacity-50"
            onClick={() => setShowModal(false)}
          ></div>
          <div className="bg-[#060125] rounded-lg py-2.5 sm:p-5 w-full max-w-[360px] z-50">
            <h2 className="text-lg sm:text-xl font-bold text-white text-center mb-4 sm:mb-6">
              Add Event
            </h2>
            {error && (
              <p className="text-red-500 text-center mb-4 text-sm">{error}</p>
            )}
            <form onSubmit={handleSubmit} className="space-y-4">
              {/* Title Input */}
              <div>
                <input
                  type="text"
                  placeholder="Enter Event Title"
                  value={newEvent.title}
                  onChange={(e) => {
                    const text = e.target.value.slice(0, 20);
                    const capitalized =
                      text.charAt(0).toUpperCase() + text.slice(1);
                    setNewEvent({ ...newEvent, title: capitalized });
                  }}
                  maxLength={20} // Add maxLength attribute
                  className="w-full bg-[#06030f] text-white p-3 rounded-md focus:outline-none focus:ring-1 focus:ring-[#D4AF37] text-sm sm:text-base"
                  required
                />
              </div>

              {/* Date Input */}
              <div>
                <input
                  type="date"
                  value={date}
                  min={formatDateToYYYYMMDD(new Date())}
                  onChange={(e) => {
                    console.log("Date input changed:", e.target.value);
                    setDate(e.target.value);
                  }}
                  className="w-full bg-[#06030f] text-white p-3 rounded-md focus:outline-none focus:ring-1 focus:ring-[#D4AF37] text-sm sm:text-base appearance-none"
                  required
                />
              </div>

              {/* Time Input */}
              <div>
                <input
                  type="time"
                  value={time}
                  onChange={(e) => {
                    console.log("Time input changed:", e.target.value);
                    setTime(e.target.value); // Store as HH:mm
                  }}
                  className="w-full bg-[#06030f] text-white p-3 rounded-md focus:outline-none focus:ring-1 focus:ring-[#D4AF37] text-sm sm:text-base appearance-none"
                  required
                />
                <p className="text-white text-[10px] mt-0.5 text-center">Notification will be sent 5 minutes prior</p>
              </div>

              {/* Case Number Dropdown */}
              <div className="relative" ref={caseDropdownRef}>
                <button
                  type="button"
                  onClick={() => setIsCaseDropdownOpen((prev) => !prev)}
                  className="w-full bg-[#06030f] text-white p-3 rounded-md focus:outline-none focus:ring-1 focus:ring-[#D4AF37] text-sm sm:text-base flex items-center justify-between text-left"
                >
                  <span className={newEvent.caseNo ? "text-white" : "text-gray-400"}>
                    {newEvent.caseNo || "Select Case"}
                  </span>
                  <ChevronDown
                    className={`w-4 h-4 text-gray-400 transition-transform ${
                      isCaseDropdownOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>
                {isCaseDropdownOpen && (
                  <div className="absolute left-0 right-0 top-full mt-1 bg-[#06030f] border border-gray-700 rounded-md shadow-lg z-20 max-h-56 overflow-y-auto">
                    {caseNumbers.length > 0 ? (
                      caseNumbers.map((caseNo, index) => (
                        <button
                          key={index}
                          type="button"
                          onClick={() => {
                            setNewEvent({ ...newEvent, caseNo });
                            setIsCaseDropdownOpen(false);
                          }}
                          className={`w-full text-left px-3 py-2 text-sm sm:text-base text-white hover:bg-[#1A1535] transition-colors ${
                            index !== caseNumbers.length - 1
                              ? "border-b border-gray-700"
                              : ""
                          }`}
                        >
                          {caseNo}
                        </button>
                      ))
                    ) : (
                      <div className="px-3 py-2 text-sm text-gray-400">
                        Loading cases...
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* Description Input - Fixed implementation */}
              <div>
                <textarea
                  placeholder="Enter Event Description (optional)"
                  value={newEvent.description}
                  onChange={(e) => {
                    const text = e.target.value.slice(0, 1000); // Limit to 1000 characters
                    setNewEvent({ ...newEvent, description: text });
                  }}
                  maxLength={1000}
                  rows={2}
                  className="w-full bg-[#06030f] text-white p-3 rounded-md focus:outline-none focus:ring-1 focus:ring-[#D4AF37] text-sm sm:text-base resize-none"
                ></textarea>
                <div className="text-xs text-gray-400 text-right mt-1">
                  {newEvent.description.length}/1000
                </div>
              </div>

              {/* Buttons */}
              <div className="flex gap-4 pt-4">
                <button
                  type="submit"
                  className="w-full bg-[#D4AF37] text-white py-2 rounded-md hover:bg-[#C4A137] transition-colors text-sm sm:text-base"
                >
                  Add
                </button>
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="w-full bg-gray-600 text-white py-2 rounded-md hover:bg-gray-700 transition-colors text-sm sm:text-base"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}


    </>
  );
}

export default AddEventModal;
